import { TOOLTIP_VARIANTS } from './config';

import TooltipWrapper from '@/components/molecules/TooltipWrapper/TooltipWrapper';

export { TOOLTIP_VARIANTS };
export default TooltipWrapper;
